export const trimResponses = (data: Record<string, any>) => {
  const trimmedResponse = Object.fromEntries(
    Object.entries(data).map(([key, value]: any) => {
      if (key === 'email') {
        return [key, value.toLowerCase().trim()]
      }
      return [key, value ? value.toString().trim() : null]
    })
  )
  return trimmedResponse
}

export const getOptionLabel = (options: any[], value: any) => {
  const entry = options.find((option) => option.value === value)
  return entry?.label
}
